/* Ecity Protection Plan — cart cleanup + plan ATC interception */
(function () {
  'use strict';

  var PLAN_IDS = [10364761801018, 10364761866554, 10364761899322, 10364761964858];
  var _cleaning = false;
  var _checkTimer = null;

  function scheduleCheck() {
    clearTimeout(_checkTimer);
    _checkTimer = setTimeout(checkOrphans, 300);
  }

  /* Inject compact property styles */
  (function(){
    if (document.getElementById('ecity-plan-css')) return;
    var s = document.createElement('style');
    s.id = 'ecity-plan-css';
    s.textContent = [
      '.cart-item .ecity-plan-props{display:flex;flex-wrap:wrap;align-items:center;gap:3px 6px;margin-top:5px;}',
      '.cart-item .ecity-plan-prop-pair{display:inline-flex;align-items:center;gap:3px;background:#f0f4ff;border:1px solid #dde8ff;border-radius:20px;padding:2px 8px;cursor:pointer;position:relative;transition:background 0.15s;}',
      '.cart-item .ecity-plan-prop-pair:hover,.cart-item .ecity-plan-prop-pair.ecity-expanded{background:#ddeaff;border-color:#b3cbff;}',
      '.cart-item .ecity-plan-prop-pair dt{display:inline;font-size:10.5px;font-weight:600;color:#0065CC;margin:0;}',
      '.cart-item .ecity-plan-prop-pair dt::after{content:": ";}',
      '.cart-item .ecity-plan-prop-pair dd{display:inline;font-size:10.5px;color:#111;margin:0;max-width:130px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transition:max-width 0.2s;}',
      '.cart-item .ecity-plan-prop-pair.ecity-expanded dd{max-width:100vw;white-space:normal;word-break:break-word;}',
      '.cart-item .ecity-plan-prop-pair .ecity-expand-hint{font-size:9px;color:#0065CC;margin-left:3px;opacity:0.6;}',
      '.cart-item .ecity-plan-prop-pair.ecity-expanded .ecity-expand-hint{display:none;}'
    ].join('');
    document.head.appendChild(s);
  })();

  /* ── FETCH WRAPPER — orphan check only ──────────────────── */
  var _origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var result = _origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : ((url && url.url) || '');
    if (/\/cart\/(change|update)(\.js)?/.test(urlStr)) {
      result.then(function () { scheduleCheck(); }).catch(function () {});
    }
    return result;
  };

  /* ── ATC FORM INTERCEPT ──────────────────────────────────────
     Strategy for cart_type=page:
     Dawn does window.location=cart_url synchronously inside its
     own .then() — page unloads before any chained fetch completes.

     Fix: intercept form SUBMIT in capture phase (before Dawn),
     snapshot+clear window._ecityPlan immediately, add plan first,
     then re-submit so Dawn handles the main item normally.

     Clearing _ecityPlan before re-submit ensures our capture
     handler does nothing on the re-submitted event — no loop.
  ─────────────────────────────────────────────────────────── */
  function attachFormIntercept() {
    var form = document.querySelector('product-form form[action="/cart/add"]') ||
               document.querySelector('form[action="/cart/add"]');
    if (!form || form._ecityIntercepted) return;
    form._ecityIntercepted = true;

    form.addEventListener('submit', function(e) {
      /* Snapshot plan and CLEAR immediately — prevents re-intercept on re-submit */
      var plan = window._ecityPlan || null;
      window._ecityPlan = null;

      /* No plan selected — let Dawn handle normally */
      if (!plan || !plan.id) return;

      /* Stop Dawn from handling this submit */
      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtn = form.querySelector('[name="add"]');

      /* Add plan first, then re-submit for Dawn to add main item */
      _origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{
          id: plan.id,
          quantity: plan.qty || 1,
          properties: {
            'Protection For': plan.title || '',
            'Article Code': plan.sku || plan.vid || '',
            '_Variant ID': plan.vid || ''
          }
        }] })
      }).catch(function() {
        /* Plan add failed silently — still proceed with main item */
      }).then(function() {
        /* Re-submit: _ecityPlan is null so our handler won't intercept again */
        if (submitBtn && form.requestSubmit) {
          form.requestSubmit(submitBtn);
        } else {
          var evt = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(evt);
        }
        /* Re-attach after Dawn processes so next ATC on same page works */
        setTimeout(function() {
          form._ecityIntercepted = false;
          attachFormIntercept();
        }, 2000);
      });
    }, true); /* capture:true — fires before Dawn's bubble listener */
  }

  document.addEventListener('DOMContentLoaded', function() {
    attachFormIntercept();
    /* Re-attach after variant re-renders */
    setTimeout(attachFormIntercept, 1000);
    setTimeout(attachFormIntercept, 3000);

    /* Orphan check subscriptions */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function() { scheduleCheck(); }); } catch(e) {}
    }
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      new MutationObserver(function() { scheduleCheck(); })
        .observe(bubble, { childList: true, subtree: true, characterData: true });
    }
    if (window.location.pathname.indexOf('/cart') !== -1) {
      setTimeout(checkOrphans, 500);
    }
  });

  function checkOrphans() {
    if (_cleaning) return;
    _origFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        var mainQty = {};
        items.forEach(function(item) {
          if (PLAN_IDS.indexOf(item.product_id) === -1) {
            mainQty[String(item.variant_id)] = (mainQty[String(item.variant_id)] || 0) + item.quantity;
          }
        });
        var orphans = [];
        items.forEach(function(item) {
          if (PLAN_IDS.indexOf(item.product_id) !== -1) {
            var linked = item.properties && item.properties['_Variant ID'];
            if (linked && !mainQty[String(linked)]) orphans.push(item.key);
          }
        });
        if (orphans.length) removeOrphans(orphans.slice());
        setTimeout(function() {
          compactPlanProps(items);
          injectNotices(items, mainQty);
          capPlanQtyInputs(items, mainQty);
        }, 150);
      }).catch(function() {});
  }

  function removeOrphans(keys) {
    if (!keys.length) { _cleaning = false; return; }
    _cleaning = true;
    var key = keys.shift();
    _origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function() { removeOrphans(keys); })
      .catch(function() { _cleaning = false; });
  }

  /* --- Compact pill properties --- */
  function compactPlanProps(items) {
    if (window.location.pathname.indexOf('/cart') === -1) return;
    var rows = document.querySelectorAll('.cart-item');
    if (!rows.length) return;
    var keyMap = {};
    items.forEach(function(item) { keyMap[item.key] = item; });
    rows.forEach(function(row, rowIdx) {
      var itemKey = getItemKey(row, items, rowIdx);
      if (!itemKey || !keyMap[itemKey]) return;
      var item = keyMap[itemKey];
      if (PLAN_IDS.indexOf(item.product_id) === -1) return;
      if (row.querySelector('.ecity-plan-props')) return;
      var dl = row.querySelector('.cart-item__details dl');
      if (!dl) return;
      var pairs = dl.querySelectorAll('.product-option');
      if (!pairs.length) return;
      var propsDiv = document.createElement('div');
      propsDiv.className = 'ecity-plan-props';
      pairs.forEach(function(pair) {
        var dt = pair.querySelector('dt');
        var dd = pair.querySelector('dd');
        if (!dt || !dd) return;
        var keyName = dt.textContent.replace(':', '').trim();
        if (keyName.charAt(0) === '_') return;
        var fullVal = dd.textContent.trim();
        var pill = document.createElement('div'); pill.className = 'ecity-plan-prop-pair';
        var dtEl = document.createElement('dt'); dtEl.textContent = keyName;
        var ddEl = document.createElement('dd'); ddEl.textContent = fullVal;
        var hint = document.createElement('span'); hint.className = 'ecity-expand-hint'; hint.textContent = '...';
        pill.appendChild(dtEl); pill.appendChild(ddEl); pill.appendChild(hint);
        pill.addEventListener('click', function(e) {
          e.stopPropagation();
          var isExpanded = pill.classList.contains('ecity-expanded');
          propsDiv.querySelectorAll('.ecity-plan-prop-pair').forEach(function(p) { p.classList.remove('ecity-expanded'); });
          if (!isExpanded) pill.classList.add('ecity-expanded');
        });
        propsDiv.appendChild(pill);
      });
      document.addEventListener('click', function() {
        propsDiv.querySelectorAll('.ecity-plan-prop-pair').forEach(function(p) { p.classList.remove('ecity-expanded'); });
      });
      if (propsDiv.children.length) {
        dl.style.display = 'none';
        dl.parentNode.insertBefore(propsDiv, dl.nextSibling);
      }
    });
  }

  /* --- Cap plan qty inputs --- */
  function capPlanQtyInputs(items, mainQty) {
    if (window.location.pathname.indexOf('/cart') === -1) return;
    var rows = document.querySelectorAll('.cart-item');
    if (!rows.length) return;
    var keyMap = {};
    items.forEach(function(item) { keyMap[item.key] = item; });
    rows.forEach(function(row, rowIdx) {
      var itemKey = getItemKey(row, items, rowIdx);
      if (!itemKey || !keyMap[itemKey]) return;
      var item = keyMap[itemKey];
      if (PLAN_IDS.indexOf(item.product_id) === -1) return;
      var linked = item.properties && item.properties['_Variant ID'];
      var maxQty = linked ? (mainQty[String(linked)] || 1) : 1;
      var qtyInput = row.querySelector('input.quantity__input, input[name="updates[]"]');
      var plusBtn = row.querySelector('button[name="plus"]');
      if (qtyInput) {
        qtyInput.setAttribute('max', maxQty);
        if (qtyInput._ecityCapHandler) {
          qtyInput.removeEventListener('change', qtyInput._ecityCapHandler);
          qtyInput.removeEventListener('input', qtyInput._ecityCapHandler);
        }
        qtyInput._ecityCapHandler = function() {
          var val = parseInt(this.value, 10) || 1;
          if (val > maxQty) { this.value = maxQty; this.dispatchEvent(new Event('change', { bubbles: true })); }
        };
        qtyInput.addEventListener('change', qtyInput._ecityCapHandler);
        qtyInput.addEventListener('input', qtyInput._ecityCapHandler);
      }
      if (plusBtn) {
        var atMax = parseInt(qtyInput && qtyInput.value, 10) >= maxQty;
        plusBtn.disabled = atMax;
        plusBtn.style.opacity = atMax ? '0.35' : '';
        plusBtn.style.cursor = atMax ? 'not-allowed' : '';
        plusBtn.title = atMax ? 'Maximum: 1 plan per device' : '';
      }
    });
  }

  /* --- Mismatch warning --- */
  function injectNotices(items, mainQty) {
    var rows = document.querySelectorAll('.cart-item');
    if (!rows.length) return;
    var keyMap = {};
    items.forEach(function(item) { keyMap[item.key] = item; });
    rows.forEach(function(row, rowIdx) {
      var existingNotice = row.querySelector('.ecity-plan-notice');
      var itemKey = getItemKey(row, items, rowIdx);
      if (!itemKey || !keyMap[itemKey]) { if (existingNotice) existingNotice.remove(); return; }
      var item = keyMap[itemKey];
      if (PLAN_IDS.indexOf(item.product_id) === -1) { if (existingNotice) existingNotice.remove(); return; }
      var linked = item.properties && item.properties['_Variant ID'];
      var deviceQty = linked ? (mainQty[String(linked)] || 0) : 0;
      var planQty = item.quantity;
      if (deviceQty <= planQty) { if (existingNotice) existingNotice.remove(); return; }
      var html = '<div style="display:flex;align-items:flex-start;gap:6px;background:#fff3cd;border:1px solid #ffc107;border-radius:6px;padding:7px 10px;margin-top:6px;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#b45309" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg><span style="font-size:11.5px;color:#92400e;line-height:1.4;">You have <strong>' + deviceQty + ' devices</strong> but only <strong>' + planQty + ' plan' + (planQty > 1 ? 's' : '') + '</strong>. Only 1 device will be covered per plan. The serial number of the covered device will be confirmed at dispatch and sent to you by email.</span></div>';
      if (existingNotice) { existingNotice.innerHTML = html; }
      else {
        var notice = document.createElement('div'); notice.className = 'ecity-plan-notice'; notice.innerHTML = html;
        var details = row.querySelector('.cart-item__details'); if (details) details.appendChild(notice);
      }
    });
  }

  function getItemKey(row, items, rowIdx) {
    var removeLink = row.querySelector('[href*="/cart/change"], [href*="remove"], cart-remove-button a');
    if (removeLink) { var m = removeLink.getAttribute('href').match(/[?&]id=([^&]+)/); if (m) return decodeURIComponent(m[1]); }
    var idMatch = row.id && row.id.match(/CartItem-(\d+)/);
    if (idMatch) { var idx = parseInt(idMatch[1], 10) - 1; if (items[idx]) return items[idx].key; }
    if (items[rowIdx]) return items[rowIdx].key;
    return null;
  }

})();
